var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 43,
    viewBox: "0 0 41 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7542 24.7937C33.5551 24.7937 38.337 29.5755 38.337 35.3765V37.3363C38.337 39.4529 36.6124 41.0991 34.5742 41.0991H6.98046C4.86389 41.0991 3.21767 39.4529 3.21767 37.3363V35.3765C3.21767 29.5755 7.92115 24.7937 13.7221 24.7937C15.9955 24.7937 17.0146 26.0479 20.7773 26.0479C24.4617 26.0479 25.4808 24.7937 27.7542 24.7937ZM34.5742 37.3363V35.3765C34.5742 31.6137 31.517 28.5565 27.7542 28.5565C26.5783 28.5565 24.7753 29.8107 20.7773 29.8107C16.701 29.8107 14.898 28.5565 13.7221 28.5565C9.95933 28.5565 6.98046 31.6137 6.98046 35.3765V37.3363H34.5742ZM20.7773 23.5394C14.506 23.5394 9.48898 18.5224 9.48898 12.251C9.48898 6.05813 14.506 0.962686 20.7773 0.962686C26.9703 0.962686 32.0657 6.05813 32.0657 12.251C32.0657 18.5224 26.9703 23.5394 20.7773 23.5394ZM20.7773 4.72547C16.6226 4.72547 13.2518 8.17469 13.2518 12.251C13.2518 16.4058 16.6226 19.7766 20.7773 19.7766C24.8537 19.7766 28.3029 16.4058 28.3029 12.251C28.3029 8.17469 24.8537 4.72547 20.7773 4.72547Z",
    fill: "#183864"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.1090a7cf5526cb9ef4fc94292a81d291.svg";
export { ForwardRef as ReactComponent };